import React from 'react'

import Link from '@/components/link/link'

import * as styles from './title-link.module.scss'

export type Props = {
  readonly htmltag?: 'h2' | 'h3' | 'h4' | 'div'
  readonly classes?: string | null
  readonly to: string
  readonly title: string
  readonly model?: string | null
  readonly isWhite?: boolean
}

const TitleLink: React.FC<Props> = ({
  htmltag = 'h2',
  classes,
  to,
  title,
  model,
  isWhite = false
}) => {
  const TagName = htmltag
  return (
    <TagName className={classes ?? ''}>
      <Link
        to={to}
        className={`${styles.titlelink} ${isWhite ? styles.white : ''}`}
      >
        {model ? <span>{model} / </span> : null}
        {title}
      </Link>
    </TagName>
  )
}

export default TitleLink
